import { render } from "./moh711a.vue?vue&type=template&id=6bf84495&scoped=true"
import script from "./moh711a.vue?vue&type=script&lang=js"
export * from "./moh711a.vue?vue&type=script&lang=js"

import "./moh711a.vue?vue&type=style&index=0&id=6bf84495&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf84495"]])

export default __exports__